import { makeImageUrls, ImageProps } from "@ezbuy/smartimagesrc";

const defaultImage = "https://i.ezbuy.sg/FrpwcmN5EALyTD7dQ06ASCe8Nkbc";

export function* imageSourceGenerator(
	originSrc: string,
	params: ImageProps,
	fallbackSrc: string | false = defaultImage,
) {
	const urls = makeImageUrls(originSrc, params);

	if (fallbackSrc) {
		urls.push(fallbackSrc);
	}
	for (let i = 0, l = urls.length; i < l; i++) {
		yield urls[i];
	}
	return originSrc;
}
